import React, {useMemo, useContext} from 'react';
import * as css from './WhatsAppPreview.css';
import {getTs,  tsToDate} from '../../../../library/dates';
import {useSelector} from 'react-redux';
import {useVariables} from '../../../../assets/objects/Variables';
import {useTranslation} from 'react-i18next';
import sanitizeHtml from '../../../../library/sanitizeHtml';
import LinkIcon from './linkIcon/LinkIcon';
import {IS_NEW_TEMPLATE} from '../../../../config/config';
import {useBrandingParams} from '../../../../hooks/useBrandingParams';
import {toCamelCase} from '../../../../functions/camelSnakeCaseConversion';
import {toKebabForDataCy} from '../../../../functions/toKebabForDataCy';
import {convertToHtml} from '../../../../component/whatsAppTemplateEditor/utils/formatUtils';
import {BrandingContext} from '../../context/BrandingContext';
import {getWhatsAppImagePath} from '../getWhatsAppImagePath';
import {useDefaultFbImage} from '../../../../hooks/useDefaultFbImage';

function WhatsAppPreview({brandingPreview}) {
    const {messageType} = useBrandingParams();
    const {defaultVariables} = useVariables();
    const {t} = useTranslation('variables');
    const {whatsappContent, currentLang, whatsappImage} = useSelector(s => ({
        currentLang: s.branding.currentLang,
        whatsappContent: s.branding.data?.[s.branding.currentLang]?.[messageType]?.['whatsappContent'] || '',
        whatsappImage: s.branding.data?.[s.branding.currentLang]?.[messageType]?.['whatsappImage'] || '',
    }));
    const {whatsapp: {message}} = useContext(BrandingContext);
    
    const {eventType, isWhatsAppTemplate} = useSelector(s => ({
        eventType: s.event.type,
        isWhatsAppTemplate: IS_NEW_TEMPLATE(Number(s.event.eid)),
    }));
    const isGivechak = eventType === 'givechak';
    const whatsappButtons = useMemo(() => {
        if(!whatsappContent || !Array.isArray(whatsappContent)) return [];
        return whatsappContent.filter(item => item.type === 'button');
    }, [whatsappContent]);

    const messageHtml = convertToHtml(message, defaultVariables, t);

    const defaultFbImage = useDefaultFbImage(true);
    const image = getWhatsAppImagePath(whatsappImage, defaultFbImage, eventType);
    return (
        <>
            <css.title> 
                <css.profile />
                {brandingPreview||'Tickchak'}    
            </css.title>
            <css.wrapper data-cy={'whatsAppPreview'}>
                <css.messageContainer>
                    <css.image src={image} />
                    <css.text dangerouslySetInnerHTML={sanitizeHtml(messageHtml)} />
                    {isWhatsAppTemplate && !isGivechak && <css.buttonContainer>
                        {whatsappButtons.map((button, index) => (
                            <css.linkButton key={index} data-cy={`wa-preview-action-${toKebabForDataCy(button?.value) || `item-${index}`}`}>
                                {t(toCamelCase((button.value).replace(/[[\]]/g, '')), {lng: currentLang})}
                                <LinkIcon />
                            </css.linkButton>
                        ))}
                    </css.buttonContainer>}
                    <css.time>{tsToDate(getTs(), null, null, 'HH:mm')}</css.time>
                </css.messageContainer>
            </css.wrapper>
        </>
    );
}

export default WhatsAppPreview;
